import React from 'react';
import classNames from 'classnames';

import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const months = [{
        label: 'January',
        name: 'aersurfaceJan'
    }, {
        label: 'February',
        name: 'aersurfaceFeb'
    }, {
        label: 'March',
        name: 'aersurfaceMar'
    }, {
        label: 'April',
        name: 'aersurfaceApr'
    }, {
        label: 'May',
        name: 'aersurfaceMay'
    }, {
        label: 'June',
        name: 'aersurfaceJun'
    }, {
        label: 'July',
        name: 'aersurfaceJul'
    }, {
        label: 'August',
        name: 'aersurfaceAug'
    }, {
        label: 'September',
        name: 'aersurfaceSep'
    }, {
        label: 'October',
        name: 'aersurfaceOct'
    }, {
        label: 'November',
        name: 'aersurfaceNov'
    }, {
        label: 'December',
        name: 'aersurfaceDec'
    }]

const AersurfaceCategories = props => (
    <div style={{padding: '0px 0px 10px 0px'}}>
        <FormLabel>
            <table className={classNames(props.classes.margin)} style={{fontSize: '12px'}}>
                <tbody>
                    <tr>
                        <td>Category</td>
                        <td>Description</td>
                        <td>Default</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>Midsummer with lush vegetation</td>
                        <td>Jun, Jul, Aug</td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>Autumn with unharvested cropland</td>
                        <td>Sep, Oct, Nov</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>Late autumn after frost and harvest, or winter with no snow</td>
                        <td>Dec, Jan, Feb</td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td>Winter with continuous snow on ground</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>5</td>
                        <td>Transitional spring with partial green coverage or short annuals</td>
                        <td>Mar, Apr, May</td>
                    </tr>
                </tbody>
            </table>
        </FormLabel>

        {months.map(month =>
            <FormControl key={month.name} style={{minWidth: '80px', maxWidth: '7%'}} className={classNames(props.classes.margin, props.classes.formControl)}>

                <InputLabel shrink>{month.label}</InputLabel>
                <Input
                    inputProps={{ min: "1", max: "5", step: "1" }}
                    type="number"
                    name={month.name}
                    value={props[month.name]}
                    onChange={props.handleInputChange}/>
            </FormControl>
        )}
    </div>
)
export default AersurfaceCategories;
